var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneNoBgd2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 173.36 173.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-3,.cls-4{fill:#386aff;}.cls-4,.cls-5,.cls-2{stroke-linecap:round;stroke-linejoin:round;}.cls-4,.cls-2{stroke:#386aff;stroke-width:6px;}.cls-5{fill:none;stroke:#fff;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.68,167.36c-21.55,0-41.81-8.39-57.05-23.63C-1.83,112.27-1.83,61.09,29.63,29.63,44.87,14.39,65.13,6,86.68,6s41.81,8.39,57.05,23.63c15.24,15.24,23.63,35.5,23.63,57.05s-8.39,41.81-23.63,57.05c-15.24,15.24-35.5,23.63-57.05,23.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.68,12c19.95,0,38.7,7.77,52.81,21.87,29.12,29.12,29.12,76.5,0,105.62-14.11,14.11-32.86,21.87-52.81,21.87s-38.7-7.77-52.81-21.87c-29.12-29.12-29.12-76.5,0-105.62,14.11-14.11,32.86-21.87,52.81-21.87m0-12c-22.18,0-44.37,8.46-61.29,25.39-33.85,33.85-33.85,88.74,0,122.59,16.93,16.93,39.11,25.39,61.29,25.39s44.37-8.46,61.29-25.39c33.85-33.85,33.85-88.74,0-122.59C131.05,8.46,108.87,0,86.68,0h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112.28,115.8v17.9c0,4.09-3.2,7.41-7.14,7.41H62.27c-3.95,0-7.14-3.32-7.14-7.41v-17.9h57.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.28,50.56V120.75H55.13V50.56c0-4.1,3.2-7.41,7.14-7.41h42.87c3.95,0,7.14,3.32,7.14,7.41Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 83.71,
    cy: 131.41,
    r: 4.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M55.13,49.36v-3.75c0-4.09,3.2-7.41,7.14-7.41h42.87c3.95,0,7.14,3.32,7.14,7.41v3.75H55.13Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 78.75,
    y1: 43.78,
    x2: 88.66,
    y2: 43.78
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNoBgd2);
export default __webpack_public_path__ + "static/media/phoneNoBgd2.073c523d5675fe26d0352610e82eee00.svg";
export { ForwardRef as ReactComponent };